import data from '../features/contentful/mock';

export default function () {
  this.get('https://cdn.contentful.com/*', () => [
    200,
    { 'Content-Type': 'application/json' },
    JSON.stringify(data)
  ]);
}
